<template>
   <!--  <v-layout v-resize="onResize" column style="padding: 0px">
   -->
  <transition name="fade" mode="out-in">
    <div class="bodyContent">
      <div class="textContent">
        <router-view></router-view>
      </div>
    </div>
  </transition>
<!-- </v-layout> -->
</template>
<script>
  export default {
    props:{
    },
    data: () => ({
        isMobile: false,
    }),
    methods: {
        onResize() {
          if (window.innerWidth < 769)
            this.isMobile = true;
          else{
            
            this.isMobile = false;
          }
        },
    }
  }
</script>
<style>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .1s
  }

  .fade-enter,
  .fade-leave-to
    /* .fade-leave-active in <2.1.8 */

  {
    opacity: 0
  }

  .bodyContent{
    /* Add the blur effect */

    /*background:url('../../public/img/login_taoyu2.png') rgba(255, 255, 255, 1);*/
    /*background-size: cover;*/
    /*background-blend-mode: multiply;*/
    /*background-position: center;
    background-repeat: no-repeat;
    background-size: cover;*/
  }

  .textContent{
    /*background-color: rgb(0,0,0); /* Fallback color */
    /*background-color: rgba(0,0,0, 0.4); /* Black w/opacity/see-through */
    /*color: white;
    font-weight: bold;
    
    text-align: center;*/
  }

.mobile {
  color: #333;
}

@media screen and (max-width: 768px) {
  .mobile table.v-table tr {
    max-width: 100%;
    position: relative;
    display: block;
  }

  .mobile table.v-table tr:nth-child(odd) {
    border-left: 6px solid deeppink;
  }

  .mobile table.v-table tr:nth-child(even) {
    border-left: 6px solid cyan;
  }

  .mobile table.v-table tr td {
    display: flex;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
    height: auto;
    padding: 10px;
  }

  .mobile table.v-table tr td ul li:before {
    content: attr(data-label);
    padding-right: 0.5em;
    text-align: left;
    display: block;
    color: #999;
  }
  .v-datatable__actions__select {
    width: 50%;
    margin: 0px;
    justify-content: flex-start;
  }
  .mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
    background: transparent;
  }
}
.flex-content {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.flex-item {
  padding: 5px;
  width: 50%;
  height: 40px;
  font-weight: bold;
}
</style>
